import axios, { AxiosResponse } from "axios"
import { BlogPage } from "./BlogPage"

function fetchBlog(page: string | number) {
	return axios.get<any, AxiosResponse<BlogPage>>(`/getBlog/${page}`)
}

export default fetchBlog
